import { useEffect } from "react";

const SITE_NAME = "Annapurna Home Pickles";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// CRA has no server-side rendering, so this only helps search engines that
// execute JS (Google does) and gives correct browser-tab/bookmark titles —
// it won't change what link-preview bots (WhatsApp/Facebook/Twitter) show,
// since those typically fetch the raw, un-rendered HTML.
export function useSEO({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
  }, [title, description]);
}
